package com.yogaaicoach.pages.auth.firebase

sealed class AuthError(override val message: String) : Throwable(message) {
    class InvalidEmail() : AuthError("The email address is invalid.")
    class EmailAlreadyInUse() : AuthError("This email is already registered.")
    class WeakPassword() : AuthError("Password should be at least 8 characters")
    class UserDisabled() : AuthError("This user account has been disabled.")
    class UserNotFound() : AuthError("No user found with this email.")
    class WrongPassword() : AuthError("Incorrect password.")
    class UserNotActivated() : AuthError("Your email address is not verified. Check your inbox for the verification link, or request a new one below.")
    class InvalidCredentials() : AuthError("The email or password you entered is incorrect. Please try again.")
    class TooManyAttempts() : AuthError("Too many attempts. Please try again later.")
    class Unknown(msg: String? = null) : AuthError(msg ?: "An unknown error occurred.")
}